import jQuery from 'jquery';
import {SavedListingRepository} from "./saved-listings/SavedListingRepository.js";
import {ZIDXSavedSearchForm} from "./saved-searches/savedSearchForm.js";
import { ZIDX } from "./standaloneLibrary.js";
import { LocationMegaMenu } from "./LocationMegaMenu.js";
import {AISearchIntegration} from "./AISearchIntegration.js";
import {
    ZIDXSearchFields,
    LISTING_LAYOUT_LIST, LISTING_LAYOUT_DETAIL, LISTING_LAYOUT_MAP, searchIsEmbedded
} from "./ListingModels.js";
import {
    getLayoutString, setupListingSearchInfiniteScroll
} from "./ListingRenderer.js";
import {
    checkForSearchFormChanges, dedupeSearchForm, decodeNativeSearch, buildJsonSearch, parseSearchData
} from "./SearchEngine.js";
import type { ZIDXBase } from "./base.js";

let $=jQuery.noConflict();

export function getLabel(defaultLabel: string, from: string, to: string, suffix: string): string {
    let label = defaultLabel;
    if (from == "$0" || from == "From") {
        if (to == "Any" || to == "To") {
        } else {
            label = "Up to " + to;
            if (suffix.length > 0) {
                label += suffix;
            }
        }
    } else {
        if (to == "Any" || to == "To") {
            label = from + "+";
        } else {
            label = from + "-" + to;
        }
        if (suffix.length > 0) {
            label += suffix;
        }
    }
    return label;
}

export function updateSearchFormLabels(base: ZIDXBase, postObj: ZIDXSearchFields) {
    let priceElement = <HTMLSelectElement>base.zidx.peakidxShadowRoot.getElementById("zidx_search_price_from")!;
    if(priceElement!=null) {
        let priceFromElement = <HTMLSelectElement>base.zidx.peakidxShadowRoot.getElementById("zidx_search_price_from")!;

        let priceFrom = priceFromElement.options[priceFromElement.selectedIndex].text;
        let priceToElement = <HTMLSelectElement>base.zidx.peakidxShadowRoot.getElementById("zidx_search_price_to")!;
        let priceTo = priceToElement.options[priceToElement.selectedIndex].text;
        $("#zidxSearchPriceContainer .zidxSearchLabel", base.zidx.peakidxShadowRoot).html(getLabel("Price", priceFrom, priceTo, ""));

        let bedroomsFromElement = <HTMLSelectElement>base.zidx.peakidxShadowRoot.getElementById("zidx_search_bedrooms_from")!;
        let bedroomsFrom = bedroomsFromElement.options[bedroomsFromElement.selectedIndex].text;
        let bedroomsToElement = <HTMLSelectElement>base.zidx.peakidxShadowRoot.getElementById("zidx_search_bedrooms_to")!;
        let bedroomsTo = bedroomsToElement.options[bedroomsToElement.selectedIndex].text;
        $("#zidxSearchBedroomsContainer .zidxSearchLabel", base.zidx.peakidxShadowRoot).html(getLabel("Beds", bedroomsFrom, bedroomsTo, " Beds"));

        let bathroomsFromElement = <HTMLSelectElement>base.zidx.peakidxShadowRoot.getElementById("zidx_search_bathrooms_from")!;
        let bathroomsFrom = bathroomsFromElement.options[bathroomsFromElement.selectedIndex].text;
        let bathroomsToElement = <HTMLSelectElement>base.zidx.peakidxShadowRoot.getElementById("zidx_search_bathrooms_to")!;
        let bathroomsTo = bathroomsToElement.options[bathroomsToElement.selectedIndex].text;
        $("#zidxSearchBathroomsContainer .zidxSearchLabel", base.zidx.peakidxShadowRoot).html(getLabel("Baths", bathroomsFrom, bathroomsTo, " Baths"));
    }

    let label = updateLabelValues(base, "Type", "zidxPopupType");
    $("#zidxSearchTypeContainer .zidxSearchLabel", base.zidx.peakidxShadowRoot).html(label);
    label = updateLabelValues(base, "City", "zidxPopupCity");
    $("#zidxSearchCityContainer .zidxSearchLabel", base.zidx.peakidxShadowRoot).html(label);

    updateLabelValues(base, "Type", "zidxSearchMoreType");
    updateLabelValues(base, "Frontage", "zidxSearchMoreFrontage");
    updateLabelValues(base, "Sub Type", "zidxSearchMoreSubType");
    updateLabelValues(base, "County", "zidxSearchMoreCounty");
    updateLabelValues(base, "Region", "zidxSearchMoreRegion");
    updateLabelValues(base, "View", "zidxSearchMoreView");
    updateLabelValues(base, "List Status", "zidxSearchMoreListStatus");
    updateLabelValues(base, "Style", "zidxSearchMoreStyle");
    updateLabelValues(base, "Parking", "zidxSearchMoreParking");
    updateLabelValues(base, "Status", "zidxSearchMoreStatus");
    updateLabelValues(base, "Condition", "zidxSearchMoreCondition");
    updateLabelValues(base, "Frontage", "zidxSearchMoreFrontage");
    updateLabelValues(base, "Show Listings", "zidxSearchMoreShowListings");
    updateLabelValues(base, "Pool", "zidxSearchMorePool");
    updateMoreLocationLabel(base);
}

export function updateLabelValues(base: ZIDXBase, defaultLabel: string, className: string): string {
    let label = defaultLabel;
    let arrLabel: string[] = [];
    $("." + className + " input", base.zidx.peakidxShadowRoot).each(function (this) {
        if ((this as HTMLInputElement).checked) {
            arrLabel.push($('label[for="' + this.id + '"]', base.zidx.peakidxShadowRoot).text());
        }
    });
    if (arrLabel.length > 0) {
        label = arrLabel.join(", ");
    }
    if (label == defaultLabel) {
        $("." + className + " .zidxSearchCheckboxValues", base.zidx.peakidxShadowRoot).html("");
    } else {
        $("." + className + " .zidxSearchCheckboxValues", base.zidx.peakidxShadowRoot).html(label);
    }
    return label;
}

export function updateMoreLocationLabel(base: ZIDXBase) {
    const root = base.zidx.peakidxShadowRoot;
    const $values = $("#zidxMoreLocationValues", root);
    if (!base.locationMegaMenu) return;

    if (base.locationMegaMenu.activeTab === "nearLocation" && base.locationMegaMenu.selectedPlace) {
        const r = parseInt(($("#zidxLocationRadiusSelect", root).val() || "5") as string);
        $values.text("Within " + r + " mi of " + base.locationMegaMenu.selectedPlace.formattedAddress);
    } else if (base.locationMegaMenu.activeTab === "location" && base.locationMegaMenu.locations.length > 0) {
        $values.text(base.locationMegaMenu.locations.map(l => l.value).join(", "));
    } else {
        $values.text("");
    }
}

export function updateSearchCounts(base: ZIDXBase, postObj: ZIDXSearchFields) {
    let countObj: any = {};
    for (let i in postObj) {
        if (!postObj.hasOwnProperty(i)) {
            continue;
        }
        if (i == "zidx_search_show_listings" || i == "zidx_search_location" || i == "zidx_search_latitude" || i == "zidx_search_latitude" || i == "zidx_search_longitude" || i == "zidx_offset" || i =="zidx_nearlocation_address") {
            continue;
        } else {
            if (typeof postObj[i] == "undefined") {
                continue;
            } else if (typeof postObj[i] == "number") {
                continue;
            }
            let arrValue = (<string>postObj[i]).split(",");
            let arrFinal = [];
            for (let n = 0; n < arrValue.length; n++) {
                if (arrValue[n] != "") {
                    arrFinal.push(arrValue[n]);
                }
            }
            postObj[i] = arrFinal.join(",");
            countObj[i] = arrFinal.length;
            if(i == "zidx_search_location_tags") {
                if(postObj["zidx_search_location_mode"]=="nearLocation"){
                    if(postObj["zidx_nearlocation_latitude"]+""!="") {
                        countObj[i] = 1;
                    }
                }
            }
        }
    }
    $(".zidxSearchPopupLinkArrow", base.zidx.peakidxShadowRoot).each(function (this: any) {
        let self = this;
        setTimeout(function () {
            let count = 0;
            if (typeof countObj[$(self).attr("data-field")!] != "undefined") {
                count = countObj[$(self).attr("data-field")!];
            }
            let arrow = $(self).attr("data-arrow");
            if (typeof arrow == "undefined") {
                arrow = "&#x25BC;";
            }
            if (count == 0) {
                $(self).html(arrow);
            } else {
                $(self).html("(" + count + ") " + arrow);
            }
        }, 10);
    });
}

export function closeMorePopup(base: ZIDXBase) {
    if (base.searchMorePopupOpen) {
        console.log("closeMorePopup");
        base.searchMorePopupOpen = false;

        relocateMegaMenu(base, false);

        $(".zidxSearchMorePopup", base.zidx.peakidxShadowRoot).hide();
        $(".zidxListingScrollContainer", base.zidx.peakidxShadowRoot).show();
        if ($(".zidxSearchMapLink.zidxActive", base.zidx.peakidxShadowRoot).length > 0) {
            $("#zidxMapIframe", base.zidx.peakidxShadowRoot).show();
        }
        updateSearchCounts(base, base.lastPostObj);
        console.log("checkForSearchFormChanges 2");
        checkForSearchFormChanges(base, true, true);
        base.zidx.scrollToTop();
    }
}

export function relocateMegaMenu(base: ZIDXBase, inFilter: boolean) {
    const root = base.zidx.peakidxShadowRoot;
    const popupContent = $(".zidxPopupLocation .zidxSearchPopupDivElement", root);

    if (popupContent.length === 0) return;

    if (inFilter) {
        const slot = $("#zidxMoreLocationMegaMenuSlot", root);
        if (slot.length === 0) return;

        base.megaMenuOriginalParent = popupContent[0].parentElement;

        slot.empty().append(popupContent.children());

        updateMoreLocationLabel(base);

        $(".zidxPopupLocation", root).hide();
    } else {
        if (base.megaMenuOriginalParent) {
            const slot = $("#zidxMoreLocationMegaMenuSlot", root);
            $(base.megaMenuOriginalParent).empty().append(slot.children());
            base.megaMenuOriginalParent = null;
        }
    }
}

export function searchUpdateMorePopup(base: ZIDXBase) {
    if ($(".zidxSearchMoreLink", base.zidx.peakidxShadowRoot).length == 0) {
        return;
    }
    $(".zidxSearchPopupDiv", base.zidx.peakidxShadowRoot).slideUp();
    let rect = $(".zidxSearchMoreLink", base.zidx.peakidxShadowRoot)[0].getBoundingClientRect();
    if (base.searchMorePopupOpen) {
        let filterRect = $(".zidxSearchMoreLink", base.zidx.peakidxShadowRoot)[0].getBoundingClientRect();
        let searchRect = $(".zidxSearchBox", base.zidx.peakidxShadowRoot)[0].getBoundingClientRect();
        $(".zidxSearchMorePopup", base.zidx.peakidxShadowRoot).css({
            "left": +"0px",
            "top": Math.round(filterRect.bottom - searchRect.top) + "px",
            "display": "block",
            "position": "absolute",
            "z-index": 1000000
        });

        relocateMegaMenu(base, true);

        let newHeight = base.zidx.windowSize.height - 95;
        base.zidx.jumpToId("searchJumpTopForm", 0);
    }
    updateSearchCounts(base, base.lastPostObj);
}

export function idxSearchResize(base: ZIDXBase) {
    if ($(".zidxPageActive .zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).length==0) {
        return;
    }
    searchUpdateMorePopup(base);
    let layout = LISTING_LAYOUT_LIST;
    let $detailLink = $(".zidxSearchDetailLink", base.zidx.peakidxShadowRoot);
    if ($detailLink.length == 0) {
        return;
    }
    if ($detailLink.hasClass("zidxActive")) {
        layout = LISTING_LAYOUT_DETAIL;
    } else if ($(".zidxSearchMapLink", base.zidx.peakidxShadowRoot).hasClass("zidxActive")) {
        layout = LISTING_LAYOUT_MAP;
    }
    if (base.zidx.windowSize.width < 992) {
        if (base.lastPostObj.zidx_layout == LISTING_LAYOUT_DETAIL) {
            $(".zidxSearchListLink", base.zidx.peakidxShadowRoot).trigger("click");
            $("#zidx_layout", base.zidx.peakidxShadowRoot).val(LISTING_LAYOUT_LIST);
            base.lastPostObj.zidx_layout = LISTING_LAYOUT_LIST;
            layout = LISTING_LAYOUT_LIST;
        }
        if ($detailLink[0].style.display != "none") {
            $detailLink.hide();
            $detailLink.blur();
        }
    } else if ($detailLink[0].style.display == "none") {
        $detailLink.show();
        $detailLink.blur();
    }
    $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).removeClass("zidxList").removeClass("zidxDetail").removeClass("zidxMap").addClass(getLayoutString(base, layout));
    let mapElement = base.zidx.peakidxShadowRoot.getElementById("zidxMapIframe") as HTMLIFrameElement;


    if (layout == LISTING_LAYOUT_LIST || layout == LISTING_LAYOUT_DETAIL) {
        $(".zidxSearchMapContainer", base.zidx.peakidxShadowRoot).hide();
        let container = $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot)[0];
        let containerPosition = container.getBoundingClientRect();
        if(mapElement) {
            mapElement.style.display = "none";
        }
        $(".zidxFooterDisclaimerContainer", base.zidx.peakidxShadowRoot).css({"float":"left","width":"100%"});
    } else if (layout == LISTING_LAYOUT_MAP) {
        if (base.zidx.windowSize.width < 767) {
            $(".zidxFooterDisclaimerContainer", base.zidx.peakidxShadowRoot).css({"float": "left", "width": "100%"});
        }else {
            $(".zidxFooterDisclaimerContainer", base.zidx.peakidxShadowRoot).css({"float": "left", "width": "50%"});
        }
        $(".zidxSearchMapContainer", base.zidx.peakidxShadowRoot).hide();
        let searchResultsContainer = $(".zidxSearchResultsContainer", base.zidx.peakidxShadowRoot)[0];
        let searchResultsContainerPosition=searchResultsContainer.getBoundingClientRect();
        $(".zidxSearchMapContainer", base.zidx.peakidxShadowRoot).show();
        let mapContainer = $(".zidxSearchMapContainer", base.zidx.peakidxShadowRoot)[0];
        let mapHeight=Math.round(base.zidx.windowSize.height*.8);
        if(base.zidx.windowHeight!=0){
            mapHeight=Math.round(base.zidx.windowHeight*.8);
        }

        mapContainer.style.height = mapHeight+"px";
        let mapContainerPosition = mapContainer.getBoundingClientRect();
        if(window.scrollY<mapContainerPosition.top) {
            mapHeight=base.zidx.windowSize.height - mapContainerPosition.top+window.scrollY;
            if(base.zidx.windowHeight!=0){
                mapHeight=base.zidx.windowHeight - mapContainerPosition.top+window.scrollY;
            }
        }
        if(mapElement) {
            if ($("#zidxComponentContainer", base.zidx.peakidxShadowRoot).length == 0) {
                mapElement.style.left = Math.round(mapContainerPosition.x + 10) + "px";
            } else {
                let bodyRect = $("#zidxComponentContainer", base.zidx.peakidxShadowRoot)[0].getBoundingClientRect();
                mapElement.style.left = Math.round(mapContainerPosition.x - bodyRect.x + 10) + "px";
            }
            if (base.zidx.windowSize.width < 767) {
                let marginLeftPercent = (mapContainerPosition.x / base.zidx.windowSize.width) * 100;
                mapElement.width = (mapContainerPosition.width - 20) + "px";
            } else {
                mapElement.width = (mapContainerPosition.width - 20) + "px";
            }
            mapElement.style.display = "block";
            mapElement.height = mapHeight+"";
            mapContainer.style.height = mapHeight+"px";
        }
        $(".zidxLoadMoreContainer", base.zidx.peakidxShadowRoot).show();
        if(base.zidx.inIframe()) {
            $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).css("min-height", (500 - searchResultsContainerPosition.y-50)+"px");
        }else{
            $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).css("min-height", (base.zidx.windowSize.height - searchResultsContainerPosition.y-50)+"px");
        }
        if(base.zidx.windowHeight!=0) {
            $("#zidx_map_height", base.zidx.peakidxShadowRoot).val(base.zidx.windowHeight - searchResultsContainerPosition.y);
        }else{
            $("#zidx_map_height", base.zidx.peakidxShadowRoot).val(base.zidx.windowSize.height - searchResultsContainerPosition.y);
        }
        base.zidx.setMapPosition(true);
    }
}

export function loadCurrentSearchCriteria(base: ZIDXBase, loadCurrentSearchFromLocal: boolean) {
    parseSearchData(base);
    let isJSON = ($("#zidx_current_search_is_json", base.zidx.peakidxShadowRoot).val()! as string) == "true";
    let currentSearch = $("#zidx_current_search", base.zidx.peakidxShadowRoot).val()! as string;
    // console.log("loadCurrentSearchCriteria", isJSON, currentSearch);

    const afterApply = () => {
        base.json = currentSearch;
        let sortField = $("#zidx_search_sort", base.zidx.peakidxShadowRoot)[0] as HTMLInputElement;
        if (sortField.value == "") {
            sortField.value = "0";
        }
        $("#zidxSearchSortField", base.zidx.peakidxShadowRoot).val(sortField.value);

        let postObjTemp = base.zidx.getFormDataByFormId("zidxSearchTopForm");
        base.lastPostObj = dedupeSearchForm(base, postObjTemp);
        let searchBoxRect = $(".zidxSearchBox", base.zidx.peakidxShadowRoot)[0].getBoundingClientRect();
        if (searchBoxRect.width < 992) {
            if (base.lastPostObj.zidx_layout == LISTING_LAYOUT_DETAIL) {
                $("#zidx_layout", base.zidx.peakidxShadowRoot).val(LISTING_LAYOUT_LIST);
                base.lastPostObj.zidx_layout = LISTING_LAYOUT_LIST;
            }
            $(".zidxSearchDetailLink", base.zidx.peakidxShadowRoot).hide();
        }
        updateSearchFormLabels(base, base.lastPostObj);
        setupListingSearchInfiniteScroll(base);

        $(".zidxSearchContainer", base.zidx.peakidxShadowRoot).css("opacity", 1);
        $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).removeClass("zidxList");
        $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).removeClass("zidxDetail");
        $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).removeClass("zidxMap");
        $(".zidxSearchListLink", base.zidx.peakidxShadowRoot).removeClass("zidxActive");
        $(".zidxSearchDetailLink", base.zidx.peakidxShadowRoot).removeClass("zidxActive");
        $(".zidxSearchMapLink", base.zidx.peakidxShadowRoot).removeClass("zidxActive");
        if (base.lastPostObj.zidx_layout == LISTING_LAYOUT_LIST) {
            $(".zidxSearchListLink", base.zidx.peakidxShadowRoot).addClass("zidxActive");
            $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).addClass("zidxList");
            $(".zidxSearchMapContainer", base.zidx.peakidxShadowRoot).hide();
            $(".zidxFooterDisclaimerContainer", base.zidx.peakidxShadowRoot).css("width", "100%");
        } else if (base.lastPostObj.zidx_layout == LISTING_LAYOUT_DETAIL) {
            $(".zidxSearchDetailLink", base.zidx.peakidxShadowRoot).addClass("zidxActive");
            $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).addClass("zidxDetail");
            $(".zidxSearchMapContainer", base.zidx.peakidxShadowRoot).hide();
            $(".zidxFooterDisclaimerContainer", base.zidx.peakidxShadowRoot).css("width", "100%");
        } else if (base.lastPostObj.zidx_layout == LISTING_LAYOUT_MAP) {
            $(".zidxSearchMapLink", base.zidx.peakidxShadowRoot).addClass("zidxActive");
            $(".zidxSearchResultsGridContainer", base.zidx.peakidxShadowRoot).addClass("zidxMap");
            $(".zidxSearchMapContainer", base.zidx.peakidxShadowRoot).show();
            if (base.zidx.windowSize.width < 767) {
                $(".zidxFooterDisclaimerContainer", base.zidx.peakidxShadowRoot).css({"float": "left", "width": "100%"});
            } else {
                $(".zidxFooterDisclaimerContainer", base.zidx.peakidxShadowRoot).css({"float": "left", "width": "50%"});
            }
        }
        updateSearchCounts(base, base.lastPostObj);
        if (base.lastPostObj.zidx_layout == LISTING_LAYOUT_MAP) {
            base.loadMap(function () {
                idxSearchResize(base);
                base.zidx.zidxMap.displayMapMarkers();
            });
        } else {
            idxSearchResize(base);
        }
    };

    if (loadCurrentSearchFromLocal) {
        decodeNativeSearch(base, currentSearch, isJSON, afterApply);
    } else {
        try {
            decodeNativeSearch(base, currentSearch, isJSON, afterApply);
        } catch (e) {
            console.log("error decoding native search", e);
            if (!base.zidx.options.inAccount) {
                if (currentSearch != "") {
                    $("#zidx_current_search", base.zidx.peakidxShadowRoot).val("");
                    loadCurrentSearchCriteria(base, false);
                }
            }
            return;
        }
    }
}

export function setupSearchFormOnce(base: ZIDXBase) {
    if (base.searchFormSetupOnce) {
        return;
    }
    base.searchFormSetupOnce = true;
    let self = base;
    $(document).on("click", function (this: any, e: JQuery.ClickEvent) {
        let hitMenu = false;
        if (self.skipMenuHitText) {
            self.skipMenuHitText = false;
            return;
        }
        $(".zidxPopupLocation", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $(".zidxLocationPillbox", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $("#zidxLocationTagResults", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $("#zidxLocationAddressSuggestions", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $(".zidxSiteHome input, .zidxSiteHome select", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $(".zidxSearchPopupLink", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $(".zidxSearchPopupLink", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $(".zidxSearchPopupDiv", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $(".zidxSearchMorePopupBorder", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $(".zidxSearchMoreLink", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        $(".zidxSearchElementField", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                hitMenu = true;
            }
        });
        // sort must be last
        $(".zidxSearchSortField", self.zidx.peakidxShadowRoot).each(function (this: any) {
            if (self.zidx.mouseHitTest(this, 0)) {
                if (!hitMenu) {
                    $(".zidxSearchPopupDiv", self.zidx.peakidxShadowRoot).slideUp();
                }
                hitMenu = true;
            }
        });
        $(".zidxSearchMoreLink", self.zidx.peakidxShadowRoot).each(function (this) {
            if (document.activeElement === this) {
                hitMenu = true;
            }
        });

        if (!hitMenu) {
            if($(".zidxSearchMorePopup", self.zidx.peakidxShadowRoot).css("display")=="block") {
                $(".zidxSearchPopupDiv", self.zidx.peakidxShadowRoot).slideUp();
                console.log("checkForSearchFormChanges 3");
                checkForSearchFormChanges(self, false, true);
                if (self.searchMorePopupOpen) {
                    closeMorePopup(self);
                }
            }
        }
    });
}

export function setupSearchForm(base: ZIDXBase, loadCurrentSearchFromLocal: boolean) {
    let self = base;
    if (base.locationMegaMenu === null) {
        base.locationMegaMenu = new LocationMegaMenu(base.zidx, base);
    }
    if(base.zidx.isAIEnabled()) {
        if (base.aiSearchIntegration === null) {
            base.aiSearchIntegration = new AISearchIntegration(base.zidx, base);
        }
        base.aiSearchIntegration.init();
    }

    $("#zidxSearchSortField", base.zidx.peakidxShadowRoot).on("change", function (this, e: JQuery.ChangeEvent) {
        let $sortField = $("#zidx_search_sort", self.zidx.peakidxShadowRoot);
        $sortField.val((this as HTMLSelectElement).options[(this as HTMLSelectElement).selectedIndex].value);
        $sortField.trigger("change");
    });
    $(".zidxSearchMoreHeading", base.zidx.peakidxShadowRoot).on("click", function (this: HTMLDivElement) {
        let group = $(this).attr("data-group");
        if (typeof group != "undefined") {
            let $group = $("." + group, self.zidx.peakidxShadowRoot);
            console.log("group", group, $group, $group.css("display"));
            if ($group.css("display") == "none") {
                $group.show();
                $(".zidxSearchPopupLinkArrow2", this).html("&#x25B2;");
                $(".zidxSearchCheckboxValues", this).hide();
            } else {
                $group.hide();
                $(".zidxSearchPopupLinkArrow2", this).html("&#x25BC;");
                $(".zidxSearchCheckboxValues", this).show();
            }
        }
    });
    $(document).on("keyup", function (event: JQuery.KeyUpEvent) {
        if (event.which === 27) {
            if (self.searchMorePopupOpen) {
                closeMorePopup(self);
            }
        }
    });

    let arrPopupLinks = ["zidxSearchPriceContainer", "zidxSearchTypeContainer", "zidxSearchBedroomsContainer", "zidxSearchBathroomsContainer"];

    for (let i = 0; i < arrPopupLinks.length; i++) {
        $("#" + arrPopupLinks[i] + " .zidxSearchPopupLink", base.zidx.peakidxShadowRoot).on("focus", function () {
            self.skipMenuHitText = true;
            $("#" + arrPopupLinks[i] + " .zidxSearchPopupLink", self.zidx.peakidxShadowRoot).trigger("click");
            self.skipMenuHitText = false;
        });
    }
    let selectKeyDown = false;
    $(".zidxSearchPopupDiv select", base.zidx.peakidxShadowRoot).on("keydown", function () {
        selectKeyDown = true;
    });
    $(".zidxSearchPopupDiv select", base.zidx.peakidxShadowRoot).on("keyup", function () {
        selectKeyDown = false;
    });
    let $searchTextFields = $("#zidxSearchTopForm input[type=text]", base.zidx.peakidxShadowRoot);
    let searchInputTimeoutID: any = 0;

    function limitWordsAndPhrases(text: string, keywordLimit: number, phraseLimit:number) {
        let arrKeyword = text.split(",");
        let arrNewKeyword=[];
        for(let i=0;i<Math.min(keywordLimit, arrKeyword.length);i++){
            let arrWord=arrKeyword[i].split(" ");
            let arrNewWord=[];
            for(let j=0;j<Math.min(phraseLimit, arrWord.length);j++){
                arrNewWord.push(arrWord[j].trim());
            }
            arrNewKeyword.push(arrNewWord.join(" "));
        }
        return arrNewKeyword.join(",");
    }
    $searchTextFields.on("input", function (this, e) {
        console.log("input", this.id);
        if(this.id=="zidx_search_building" || this.id=="zidx_search_remarks" || this.id=="zidx_search_exclude_remarks" || this.id=="zidx_search_subdivision" || this.id=="zidx_search_address"){
            let newText = limitWordsAndPhrases((this as HTMLInputElement).value, 32, 10);
            if (newText != (this as HTMLInputElement).value) {
                (this as HTMLInputElement).value = newText;
            }
        }else if(this.id=="zidx_search_postal_code" || this.id=="zidx_search_listing_id"){
            let newText = limitWordsAndPhrases((this as HTMLInputElement).value, 32, 1);
            if (newText != (this as HTMLInputElement).value) {
                (this as HTMLInputElement).value = newText;
            }
        }
        clearTimeout(searchInputTimeoutID);
        searchInputTimeoutID = setTimeout(function () {
            console.log("checkForSearchFormChanges 4");
            checkForSearchFormChanges(self, false, true);
        }, 250);
    });
    $("#zidxSearchTopForm input[type=hidden], #zidxSearchTopForm input[type=text], #zidxSearchTopForm select, #zidxSearchTopForm input[type=checkbox], #zidxSearchTopForm input[type=radio]", base.zidx.peakidxShadowRoot).on("change", function (this: any, e: JQuery.ChangeEvent) {
        let otherId: string;
        let offsetField = <HTMLInputElement>self.zidx.peakidxShadowRoot.getElementById("zidx_offset")!;
        offsetField.value = "0";
        if (this.id.substr(0, 10) == "zidx_more_") {
            otherId = "zidx_" + this.id.substr(10, this.id.length - 10);
        } else {
            otherId = "zidx_more_" + this.id.substr(5, this.id.length - 5);
        }
        if (this instanceof HTMLSelectElement) {
            let element = (<HTMLSelectElement | null>self.zidx.peakidxShadowRoot.getElementById(otherId));
            if (element) {
                element.selectedIndex = this.selectedIndex;
            }
        } else {
            let element = (<HTMLInputElement | null>self.zidx.peakidxShadowRoot.getElementById(otherId));
            if(element) {
                if (this.type == "checkbox" || this.type == "radio") {
                    if (this.checked) {
                        if (element && !element.checked) {
                            element.checked = true;
                        }
                    } else {
                        if (element && element.checked) {
                            element.checked = false;
                        }
                    }
                } else {
                    if (element && element.value != this.value) {
                        element.value = this.value;
                    }
                }
            }
        }
        if (this.searchMorePopupOpen) {
            console.log("checkForSearchFormChanges 5");
            checkForSearchFormChanges(self, false, true);
        } else {
            if (selectKeyDown) {
                console.log("checkForSearchFormChanges 6");
                checkForSearchFormChanges(self, false, true);
            } else {
                if (this.id == "zidx_search_price_to") {
                    if (self.zidx.options.debug) console.log("trigger close from price to");
                    $(".zidxPopupPrice .zidxSearchPopupApplyLink", self.zidx.peakidxShadowRoot).trigger("click");
                } else if (this.id == "zidx_search_bedrooms_to") {
                    if (self.zidx.options.debug) console.log("trigger close from bedrooms to");
                    $(".zidxPopupBedrooms .zidxSearchPopupApplyLink", self.zidx.peakidxShadowRoot).trigger("click");
                } else if (this.id == "zidx_search_bathrooms_to") {
                    if (self.zidx.options.debug) console.log("trigger close from bathrooms to");
                    $(".zidxPopupBathrooms .zidxSearchPopupApplyLink", self.zidx.peakidxShadowRoot).trigger("click");
                } else {
                    console.log("checkForSearchFormChanges 7");
                    checkForSearchFormChanges(self, false, true);
                }
            }
        }
    });
    $(".zidxSearchMorePopupResetLink", base.zidx.peakidxShadowRoot).on("click", function (e: JQuery.ClickEvent) {
        e.preventDefault();
        $(".zidxSearchSortField, .zidxSearchBox select", self.zidx.peakidxShadowRoot).each(function (this) {
            (this as HTMLSelectElement).selectedIndex = 0;
        });
        $("#zidx_search_sort", self.zidx.peakidxShadowRoot).val("1");
        $("#zidx_offset", self.zidx.peakidxShadowRoot).val("0");
        $("#zidx_search_polygon, #zidx_search_latitude, #zidx_search_longitude", self.zidx.peakidxShadowRoot).val("");
        $(".zidxSearchBox input[type='checkbox']", self.zidx.peakidxShadowRoot).each(function (this) {
            (this as HTMLInputElement).checked = false;
        });
        $(".zidxSearchBox input[type='text']", self.zidx.peakidxShadowRoot).val("");
        if (self.locationMegaMenu) {
            self.locationMegaMenu.clear();
        }

        if (self.aiSearchIntegration && self.aiSearchIntegration.isActive()) {
            // If user resets while in AI mode, exit AI mode too
        }
        let postObj = self.zidx.getFormDataByFormId("zidxSearchTopForm");
        postObj = dedupeSearchForm(self, postObj);
        updateSearchFormLabels(self, postObj);
        closeMorePopup(self);
        console.log("checkForSearchFormChanges 8");
        checkForSearchFormChanges(self, false, true);
    });

    $(".zidxSearchMorePopupShowLink", base.zidx.peakidxShadowRoot).on("click", function (e: JQuery.ClickEvent) {
        e.preventDefault();
        console.log("checkForSearchFormChanges 9");
        checkForSearchFormChanges(self, true, true);
        if($(".zidxSiteHomeContainer.zidxPageActive", self.zidx.peakidxShadowRoot).length!=0 && $(".zidxListingScrollContainer", self.zidx.peakidxShadowRoot).length==0) {
            let postObj = self.zidx.getFormDataByFormId("zidxSearchTopForm");
            postObj = dedupeSearchForm(self, postObj);

            let qs=[];
            if(postObj.zidx_search_city!=""){
                qs.push("city="+encodeURIComponent(postObj.zidx_search_city));
            }
            if(postObj.zidx_search_price_from+","+postObj.zidx_search_price_to!="0,2000000000") {
                qs.push("price=" + postObj.zidx_search_price_from + "," + postObj.zidx_search_price_to);
            }
            if(postObj.zidx_search_bedrooms_from+","+postObj.zidx_search_bedrooms_to!="0,100") {
                qs.push("bathrooms="+postObj.zidx_search_bedrooms_from+","+postObj.zidx_search_bedrooms_to);
            }
            if(postObj.zidx_search_bathrooms_from+","+postObj.zidx_search_bathrooms_to!="0,100") {
                qs.push("baths="+postObj.zidx_search_bathrooms_from+","+postObj.zidx_search_bathrooms_to);
            }
            if(postObj.zidx_search_sqft_from+","+postObj.zidx_search_sqft_to!="0,1000000000") {
                qs.push("sqft="+postObj.zidx_search_sqft_from+","+postObj.zidx_search_sqft_to);
            }
            if(postObj.zidx_search_acreage_from+","+postObj.zidx_search_acreage_to!="0,1000000000") {
                qs.push("acreage="+postObj.zidx_search_acreage_from+","+postObj.zidx_search_acreage_to);
            }
            if(postObj.zidx_search_year_built_from+","+postObj.zidx_search_year_built_to!="0,10000") {
                qs.push("yearBuilt="+postObj.zidx_search_year_built_from+","+postObj.zidx_search_year_built_to);
            }
            if(postObj.zidx_search_type!="") {
                qs.push("type=" + encodeURIComponent(postObj.zidx_search_type));
            }
            if(postObj.zidx_search_list_status!="") {
                qs.push("listStatus=" + encodeURIComponent(postObj.zidx_search_list_status));
            }
            if(postObj.zidx_search_status!="") {
                qs.push("status="+encodeURIComponent(postObj.zidx_search_status));
            }
            if(postObj.zidx_search_address!="") {
                qs.push("address="+encodeURIComponent(postObj.zidx_search_address));
            }
            if(postObj.zidx_search_remarks!="") {
                qs.push("remarks="+encodeURIComponent(postObj.zidx_search_remarks));
            }
            if(postObj.zidx_search_exclude_remarks!="") {
                qs.push("excludeRemarks="+encodeURIComponent(postObj.zidx_search_exclude_remarks));
            }
            if(postObj.zidx_search_county!="") {
                qs.push("county="+encodeURIComponent(postObj.zidx_search_county));
            }
            if(postObj.zidx_search_sub_type!="") {
                qs.push("subType="+encodeURIComponent(postObj.zidx_search_sub_type));
            }
            if(postObj.zidx_search_frontage!="") {
                qs.push("frontage="+encodeURIComponent(postObj.zidx_search_frontage));
            }
            if(postObj.zidx_search_view!="") {
                qs.push("view="+encodeURIComponent(postObj.zidx_search_view));
            }
            if(postObj.zidx_search_parking!="") {
                qs.push("parking="+encodeURIComponent(postObj.zidx_search_parking));
            }
            if(postObj.zidx_search_pool!="") {
                qs.push("pool="+encodeURIComponent(postObj.zidx_search_pool));
            }
            if(postObj.zidx_search_building!="") {
                qs.push("building="+encodeURIComponent(postObj.zidx_search_building));
            }
            if(postObj.zidx_search_style!="") {
                qs.push("style="+encodeURIComponent(postObj.zidx_search_style));
            }
            if(postObj.zidx_search_condition!="") {
                qs.push("condition="+encodeURIComponent(postObj.zidx_search_condition));
            }
            if(postObj.zidx_search_subdivision!="") {
                qs.push("subdivision="+encodeURIComponent(postObj.zidx_search_subdivision));
            }
            if(postObj.zidx_search_postal_code!="") {
                qs.push("postalCode="+encodeURIComponent(postObj.zidx_search_postal_code));
            }
            if(postObj.zidx_search_listing_id!="") {
                qs.push("listingId=" + encodeURIComponent(postObj.zidx_search_listing_id));
            }
            window.scrollTo(0,0);
            let link=self.zidx.getPrefixURL('/results/?h='+new Date().getTime()+"&"+qs.join("&"));
            self.zidx.loadPushStateURL(link, false);
            return;
        }else {
            closeMorePopup(self);
        }
    });
    $(".zidxSearchPopupLink", base.zidx.peakidxShadowRoot).on("click", function (this: any, e: JQuery.ClickEvent) {
        e.preventDefault();
        let div = $(this).attr("data-popup-div");
        let $div = $("." + div, self.zidx.peakidxShadowRoot);
        $(".zidxSearchPopupLink", self.zidx.peakidxShadowRoot).each(function (this) {
            let a = this.getAttribute("data-popup-div");
            if (div != a) {
                $("." + a, self.zidx.peakidxShadowRoot).slideUp();
            }
        });

        let postObj = self.zidx.getFormDataByFormId("zidxSearchTopForm");
        postObj = dedupeSearchForm(self, postObj);
        updateSearchCounts(self, postObj);
        if ($(this).closest(".zidxSearchMorePopupContainer").length == 0) {
            closeMorePopup(self);
            $div.slideDown("fast");
            if ($div[0].style.display == "block") {
                $(".zidxSearchPopupLinkArrow", this).attr("data-arrow", "&#x25BC;");
                console.log("checkForSearchFormChanges 10");
                checkForSearchFormChanges(self, false, true);
            } else {
                $(".zidxSearchPopupLinkArrow", this).attr("data-arrow", "&#x25B2;");
            }

            let rect=this.getBoundingClientRect();
            $div.css({"left": 0+ "px", "top": (rect.height+5) + "px"});
        } else {
            let field = $(".zidxSearchElementField", $(this).parent().parent());
            field.slideUp("fast");
            if (field[0].style.display == "block") {
                $(".zidxSearchPopupLinkArrow", this).attr("data-arrow", "&#x25BC;");
                console.log("checkForSearchFormChanges 11");
                checkForSearchFormChanges(self, false, true);
            } else {
                $(".zidxSearchPopupLinkArrow", this).attr("data-arrow", "&#x25B2;");
            }
        }

    });
    $("#zidx_search_location", base.zidx.peakidxShadowRoot).on("blur", function () {
        console.log("checkForSearchFormChanges 12");
        checkForSearchFormChanges(self, false, true);
    });
    $("#zidxSearchFormGoButton", base.zidx.peakidxShadowRoot).on("click", function () {
        console.log("checkForSearchFormChanges 13");
        checkForSearchFormChanges(self, false, true);
    });

    $(".zidxSearchPopupApplyLink", base.zidx.peakidxShadowRoot).on("click", function (this: any, e: JQuery.ClickEvent) {
        e.preventDefault();
        $(".zidxSearchPopupDiv", self.zidx.peakidxShadowRoot).slideUp();
        if(self.locationMegaMenu){
            self.locationMegaMenu.close();
        }
        console.log("checkForSearchFormChanges 15");
        checkForSearchFormChanges(self, false, true);
        if ($(this).closest(".zidxSearchMorePopupContainer").length == 0) {
            closeMorePopup(self);
        }
    });

    let fullscreenLink = $(".zidxSearchFullscreenLink", base.zidx.peakidxShadowRoot)[0] as HTMLAnchorElement;
    if (!base.enableFullscreenLink || window.location.href.indexOf('zidxFullscreen=1') != -1) {
        base.enableFullscreenLink = false;
        fullscreenLink.style.display = "none";
    } else {
    }
    $(".zidxSearchFullscreenLink", base.zidx.peakidxShadowRoot).on("click", function (e: JQuery.ClickEvent) {
        if (window.location.href.indexOf("?") == -1) {
            fullscreenLink.href = window.location.href + "?zidxFullscreen=1";
        } else {
            fullscreenLink.href = window.location.href + "&zidxFullscreen=1";
        }
        fullscreenLink.target = "_blank";
        return true;
    });
    let searchResultsResizeTimeoutId: any = null;
    let backupMapValues={latitude:"", longitude:"", polygon:""};
    $(window).on("clientresize resize", function (ev: any) {
        if ($(".zidxPageActive #zidxSearchTopForm", self.zidx.peakidxShadowRoot).length == 0) {
            return;
        }
        clearTimeout(searchResultsResizeTimeoutId);
        searchResultsResizeTimeoutId = setTimeout(function () {
            // console.log("results resize");
            idxSearchResize(self);
            $(".zidxSearchResultsGridContainer", self.zidx.peakidxShadowRoot).trigger("wheel");
        }, 50);
    });
    $(".zidxSearchListLink, .zidxSearchDetailLink, .zidxSearchMapLink", base.zidx.peakidxShadowRoot).on("click", function (this, e: JQuery.ClickEvent) {
        let layoutBackup = $("#zidx_layout", self.zidx.peakidxShadowRoot).val()! as string;
        let layout = parseInt($(this).attr("data-layout")! as string);
        $("#zidx_layout", self.zidx.peakidxShadowRoot).val(layout);
        if(!this.classList.contains("zidxSearchMapLink")){
            if($("#zidx_search_latitude", self.zidx.peakidxShadowRoot).val() != "") {
                backupMapValues.latitude = $("#zidx_search_latitude", self.zidx.peakidxShadowRoot).val()! as string;
                backupMapValues.longitude = $("#zidx_search_longitude", self.zidx.peakidxShadowRoot).val()! as string;
                backupMapValues.polygon = $("#zidx_search_polygon", self.zidx.peakidxShadowRoot).val()! as string;
            }
            $("#zidx_search_polygon", self.zidx.peakidxShadowRoot).val("");
            $("#zidx_search_latitude", self.zidx.peakidxShadowRoot).val("");
            $("#zidx_search_longitude", self.zidx.peakidxShadowRoot).val("");
        }else{
            if(backupMapValues.latitude!="" && backupMapValues.longitude!=""){
                $("#zidx_search_latitude", self.zidx.peakidxShadowRoot).val(backupMapValues.latitude);
                $("#zidx_search_longitude", self.zidx.peakidxShadowRoot).val(backupMapValues.longitude);
                $("#zidx_search_polygon", self.zidx.peakidxShadowRoot).val(backupMapValues.polygon);
            }
        }
        let postObjTemp = self.zidx.getFormDataByFormId("zidxSearchTopForm");
        self.lastPostObj = dedupeSearchForm(self, postObjTemp);
        e.preventDefault();
        $(".zidxSearchListLink, .zidxSearchDetailLink, .zidxSearchMapLink", self.zidx.peakidxShadowRoot).removeClass("zidxActive");
        $(this).addClass("zidxActive");
        $("#zidx_layout", self.zidx.peakidxShadowRoot).val(layout);
        if (self.infiniteScroll != null) {
            self.infiniteScroll.destroyPanels();
        }

        if (self.infiniteScroll != null) {
            self.infiniteScroll.resize();
        }
        let json = buildJsonSearch(self, self.lastPostObj, false);
        let contactId = self.zidx.getCookie("ZIDXCONTACTID");
        if (contactId != "" && contactId != "0") {
            json.contact_id = parseInt(contactId);
        }
        self.json = JSON.stringify(json);
        $(".zidxSearchResultsGridContainer", self.zidx.peakidxShadowRoot).scrollTop(0);
        if (this.className.indexOf("zidxSearchMapLink") != -1) {
            self.loadMap(function () {
                idxSearchResize(self);
                self.zidx.zidxMap.displayMapMarkers();
            });
        }else{
            idxSearchResize(self);
        }
        self.zidx.zidxBase.bindSaveButtons();
    });
    $(".zidxSearchMoreLink", base.zidx.peakidxShadowRoot).on("click", function (e: JQuery.ClickEvent) {
        e.preventDefault();
        if (self.searchMorePopupOpen) {
            closeMorePopup(self);
        } else {
            self.searchMorePopupOpen = true;
            $("#zidxMapIframe", self.zidx.peakidxShadowRoot).hide();
            $(".zidxListingScrollContainer", self.zidx.peakidxShadowRoot).hide();
            searchUpdateMorePopup(self);
        }
    });
    $(".zidxSearchSaveLink", base.zidx.peakidxShadowRoot).on("click", function(this:HTMLElement, e: JQuery.ClickEvent){
        e.preventDefault();
        let id=this.getAttribute("data-saved-search-id")!;
        let key=this.getAttribute("data-saved-search-key")!;
        checkForSearchFormChanges(self, false, true);
        if (self.searchMorePopupOpen) {
            closeMorePopup(self);
        }
        let savedSearchForm = new ZIDXSavedSearchForm(self.zidx, id, key);
        savedSearchForm.json = base.json;
    });
    loadCurrentSearchCriteria(base, loadCurrentSearchFromLocal);
    setupSearchFormOnce(base);
}
